import React from 'react';
import { domToReact } from 'html-react-parser';
import InlineSourceLink from '../../../../../components/Molecules/InlineSourceLink/InlineSourceLink';
import { wpFootnoteClass, collectionKey } from './Constants';
import { parserPropTypes, parserPropTypesDefaults } from '../Constants';

const toFootnote = ( parserData ) =>
{
    const { parserOptions: {replaceFn} } = parserData;
    const Wrapper = ({ 
        name = parserPropTypesDefaults.name, 
        type = parserPropTypesDefaults.type, 
        attribs = parserPropTypesDefaults.attribs,
        children = parserPropTypesDefaults.children
    }, addToCollection = null) => 
    {
        if (type !== 'tag') return null;
        if (!name || name !== 'span') return null;
        if (!attribs?.class) return null;
        if (!attribs.class.split(' ').includes(wpFootnoteClass)) return null;

        const childrenComps = domToReact(children, replaceFn());
        const { length } = addToCollection(collectionKey, childrenComps);
        
        return (
            <InlineSourceLink
                key={`footnote-${length}`}
                sourceNumber={length}
                content={childrenComps}
            />
        );
    };
    Wrapper.propTypes = parserPropTypes;
    return Wrapper;
}
export default toFootnote;
